import * as yup from 'yup'
import { emptyStringToZero } from 'common/utils/yupSchemaUtils'
import { MIN_PRODUCT_PRICE } from '../ProductForm/schema'

const trimString = (_, originalValue) => String(originalValue).trim()

export const schema = yup
  .object({
    name: yup
      .string()
      .required('Name required')
      .min(3, 'Name must be at least 3 characters')
      .max(30, 'Name must be under 30 characters')
      .transform(trimString),
    description: yup.string().max(200, 'Description must be under 200 characters'),
    price: yup
      .number()
      .transform(emptyStringToZero)
      .required('Price should be at least 4.99')
      .min(MIN_PRODUCT_PRICE, 'Price should be at least 4.99'),
  })

  .required()
